export default "__VITE_ASSET__ZXwhulrX__"